import { eventNames, trackEvent } from 'utils/instrumentation';

const bookDemo = () => {
  trackEvent(eventNames.DEMO_FORM_OPENED, {
    origin: window.location.href
  });
  window.open(
    '/demo',
    '_blank'
  );
};

export default bookDemo;